import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const InfoOverlay = styled('div')`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 50%;
  background-color: var(--white);
  padding: 30px 40px;
  border: solid 1px #e4e4e4;
  z-index: 9999;

  &::before {
    display: block;
    content: '';
    position: absolute;
    right: 100%;
    top: -1px;
    bottom: -1px;
    width: 80px;
    opacity: 0.1;
    background-image:
      linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        var(--ph-gray-500) 100%
      );
  }

  div[class*='Base-styles-Columns'] {
    position: relative;
    top: 0;
  }
`;

const CloseBtn = styled(Svg)`
  width: 15px;
  height: 15px;
  cursor: pointer;
  position: absolute;
  top: 48px;
  right: 40px;

  path {
    fill: var(--dark-grey);
  }
`;

const Title = styled('h1')`
  font-size: var(--ph-heading-three);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);
`;

const Box = styled('div')`
  margin: 0 -20px;
  overflow-y: auto;
  height: calc(100% - 70px);

  div[class*="DataGrid-styles-table"] {
    border-bottom: 0;
  }

  div[class*="Pagination-styles-MiddleText"] {
    display: none;
  }
`;

export default {
  InfoOverlay,
  CloseBtn,
  Title,
  Box,
};
